document.addEventListener("DOMContentLoaded", () => {

    i18next
        .use(i18nextBrowserLanguageDetector)
        .use(i18nextChainedBackend)
        .init({
            fallbackLng: 'en',
            supportedLngs: ['en', 'es'],
            load: 'languageOnly',
            // debug: true,
            detection: {
                order: ['navigator'],
                lookupFromPath: false,
                caches: [],
                allowlist: ['en', 'es']
            },
            backend: {
                backends: [
                    i18nextLocalStorageBackend,
                    i18nextHttpBackend
                ],
                backendOptions: [{
                    expirationTime: 24 * 60 * 60 * 1000, // 7 days
                    // expirationTime: 60 * 1000, // 1 min
                    defaultVersion: 'v1.0.2'
                }, {
                    loadPath: 'https://sharkiller.dev/videoplayer/translations/{{lng}}/{{ns}}.json?v'+Math.floor(Math.random() * 1000000)
                }]
            }
        });
    // i18next
    //     .use(i18nextBrowserLanguageDetector)
    //     .use(i18nextHttpBackend)
    //     .init({
    //         fallbackLng: 'en',
    //         supportedLngs: ['en', 'es'],
    //         load: 'languageOnly',
    //         debug: true,
    //         backend: {
    //             loadPath: 'https://sharkiller.dev/videoplayer/translations/{{lng}}/{{ns}}.json'
    //         }
    //     });

    function updateContent() {
        document.querySelector('html').setAttribute('lang', i18next.resolvedLanguage);
        document.querySelectorAll('[data-i18n]').forEach(el => {
            const key = el.getAttribute('data-i18n');
            if (key.startsWith('[html]')) {
                el.innerHTML = i18next.t(key.slice(6));
            } else if (key.startsWith('[placeholder]')) {
                el.setAttribute('placeholder', i18next.t(key.slice(13)));
            } else {
                el.textContent = i18next.t(key);
            }
        });
    }
    window.updateContent = updateContent;

    function changeLng(lng) {
        i18next.changeLanguage(lng);
    }
    window.changeLng = changeLng;

    let i18nextInitialized = false;
    i18next.on('initialized', () => {
        i18nextInitialized = true;
        updateContent();
    });

    i18next.on('languageChanged', () => {
        if(i18nextInitialized) {
            updateContent();
        }
    });

});




